import DriverAssets from "../../../views/DriverAssets";
import Assets from "../../../views/Assets";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const DriverAssetsRoutes = [
  {
    menuName: MenuNames.DRIVER_ASSETS,
    path: "/driver-assets",
    component: DriverAssets,
    exact: true,
  },
  {
    menuName: MenuNames.DRIVER_ASSETS,
    path: "/driver-assets-bulk",
    component: DriverAssets,
    exact: true,
  },
  {
    menuName: MenuNames.DRIVER_ASSETS,
    path: "/driver-assets-bulk-pickup",
    component: DriverAssets,
    exact: true,
  },
  {
    menuName: MenuNames.DRIVER_ASSETS,
    path: "/assets",
    component: Assets,
    exact: true,
  },
];

export default DriverAssetsRoutes;
